import intersection from 'lodash/intersection';

export const validateRoles = (userRoles, availableRoles) =>
  Array.isArray(availableRoles)
    ? intersection(userRoles, availableRoles).length > 0
    : userRoles.includes(availableRoles);
